import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute, Link, useNavigate } from "@tanstack/react-router"

import { Button } from "@/components/ui/button"
import { EndAppointmentJourney } from "@/features/appointments/components/end-appointment-journey"
import { appointmentQueries } from "@/queries/appointments"

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/firms/$firmId/people/$appointmentId/end/"
)({
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(
      appointmentQueries.detail(params.appointmentId)
    ),
  component: EndAppointmentPage,
})

/** End someone's appointment at the firm, one question at a time. */
function EndAppointmentPage() {
  const { firmId, appointmentId } = Route.useParams()
  const { data: appointment } = useSuspenseQuery(
    appointmentQueries.detail(appointmentId)
  )
  const navigate = useNavigate()

  return (
    <EndAppointmentJourney
      appointment={appointment}
      cancel={
        <Button
          variant="ghost"
          nativeButton={false}
          render={
            <Link
              from="/$organisation"
              to="/$organisation/firms/$firmId/people"
              params={{ firmId }}
            />
          }
        >
          Cancel
        </Button>
      }
      onFinished={() =>
        void navigate({
          from: "/$organisation",
          to: "/$organisation/firms/$firmId/people",
          params: { firmId },
        })
      }
    />
  )
}
